__turbopack_context__.v({
  "content": "hQSIKG_content",
  "imgContainer": "hQSIKG_imgContainer",
  "imgInfoElement": "hQSIKG_imgInfoElement",
  "root": "hQSIKG_root",
});
